export default __webpack_public_path__ + "static/media/metro.7096b489.jpg";